// test289
(289 && 0);
